module.exports = __webpack_public_path__ + "static/img/row6.3466939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/mobile/row6.png
// module id = 2CH+
// module chunks = 12